import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, Sparkles } from "lucide-react";
import api from "../api/client";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const { user } = useAuth();
  const { t } = useLang();

  useEffect(() => {
    api.get("/testimonials").then((r) => setTestimonials(r.data || [])).catch(() => {});
  }, []);

  return (
    <div className="bg-[var(--bg)]" data-testid="testimonials-page">
      <section className="pt-28 md:pt-32 pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-12 gap-10 mb-14 items-end">
            <div className="md:col-span-7">
              <p className="overline mb-4">{t("testimonials.overline")}</p>
              <h1 className="font-serif font-light text-5xl sm:text-6xl text-[color:var(--ink)] tracking-tight leading-[1.05]">
                {t("testimonials.title")}
              </h1>
            </div>
            <p className="md:col-span-5 text-[color:var(--ink-2)] text-lg leading-relaxed">
              {t("testimonials.lead")}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="testimonials-grid">
            {testimonials.length === 0 && (
              <p className="text-[color:var(--ink-3)] italic font-serif col-span-full" data-testid="testimonials-empty">
                {t("common.stories_coming")}
              </p>
            )}
            {testimonials.map((tt, i) => (
              <article
                key={tt.id}
                className={`card-soft p-7 ${i % 3 === 1 ? "md:translate-y-6" : ""}`}
                data-testid={`testimonial-${tt.id}`}
              >
                <Quote size={20} strokeWidth={1.2} className="text-[color:var(--accent)] mb-4" />
                <p className="font-serif text-xl leading-snug text-[color:var(--ink)]">
                  {tt.content}
                </p>
                <div className="mt-6 pt-5 border-t border-[color:var(--line-soft)]">
                  <p className="text-[color:var(--ink)] font-medium text-sm">{tt.name}</p>
                  {tt.role_label && <p className="text-[color:var(--ink-3)] text-xs mt-1">{tt.role_label}</p>}
                </div>
              </article>
            ))}
          </div>

          {user && user.role === "client" && (
            <div className="mt-14 text-center">
              <Link to="/dashboard" className="btn-ghost" data-testid="cta-share-story">
                <Sparkles size={16} strokeWidth={1.4} /> {t("common.share_story")}
              </Link>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
